import { render, staticRenderFns } from "./AppointmentFilter.vue?vue&type=template&id=4e10b70c&scoped=true&"
import script from "./AppointmentFilter.vue?vue&type=script&lang=js&"
export * from "./AppointmentFilter.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentFilter.vue?vue&type=style&index=0&id=4e10b70c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e10b70c",
  null
  
)

export default component.exports